// Copyright (c) StrangeBee 2024

import { ICONS } from '@Constants/iconsApp';
import { useLocalMessage } from '@Helpers/locale';
import { PropRender } from '@Organisms/LiveStreamData/PropRenderer/PropRenderer';
import StreamCard from '@Organisms/LiveStreamData/StreamCard/StreamCard';
import RouteBuilder from '@Services/RouteBuilder';
import React, { ReactElement } from 'react';
import { CardContentProps } from '../CardContentType';

const fieldListHidden = ['_id', '_type', '_createdBy', '_createdAt', 'sourceRef', 'extraData'];

export const AlertContent = ({ data, base }: CardContentProps): ReactElement => {
    const local = useLocalMessage();

    const { title = '', source = '', _id: alertId } = data || {};

    const { _id, details, action } = base;

    const libTitle = {
        create: local('stream.card.alert.create'),
        update: local('stream.card.alert.update'),
        delete: local('stream.card.alert.delete'),
    };

    const titleCard = action === 'delete' ? libTitle.delete : `[${source}] ${title}`;

    return (
        <StreamCard
            icon={<ICONS.AlertIcon />}
            title={titleCard}
            path={RouteBuilder.compute('alerts.details', { alertId })}
            base={base}
        >
            {Object.entries(details)
                .filter(([key]) => !fieldListHidden.includes(key))
                .map(([key, value]) => (
                    <PropRender key={key + _id} prop={key} value={value} type="alert" />
                ))}
        </StreamCard>
    );
};
